export default "__VITE_ASSET__Cshf_stG__"